var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manage-badge"},_vm._l((_vm.badges),function(item,index){return _c('div',{key:index},[(item.type)?_c('ReadinessBadge',{attrs:{"level":item.badge_id,"dot":item.type,"view":"ReadOnly"}}):_vm._e(),(!item.type )?_c('GrantOrForceButton',{attrs:{"proficiencyLevel":item.badge_id,"isForce":!!item.is_force}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }